// extracted by mini-css-extract-plugin
module.exports = {"card":"ModalContent_card__1z9VJ","contentContainer":"ModalContent_contentContainer__31-ZS","messageContainer":"ModalContent_messageContainer__n-P-V"};